// Mantém apenas os caracteres válidos de um CNPJ alfanumérico (0-9 e A-Z),
// em caixa alta. A partir de jul/2026 as 12 primeiras posições podem ser
// letras; os 2 dígitos verificadores continuam numéricos.
export const onlyCnpjChars = (v) =>
  String(v ?? "")
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, "");

export const maskCPF = (cpf) => {
  cpf = String(cpf ?? "").replace(/\D/g, "");
  if (cpf.length <= 11) {
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d)/, "$1.$2");
    cpf = cpf.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  }
  return cpf;
};

// CNPJ alfanumérico: máscara XX.XXX.XXX/XXXX-DD onde as 12 primeiras posições
// aceitam letras ou números e os 2 últimos (DV) são numéricos.
export const maskCNPJ = (cnpj) => {
  cnpj = onlyCnpjChars(cnpj).slice(0, 14);
  cnpj = cnpj.replace(/^([0-9A-Z]{2})([0-9A-Z])/, "$1.$2");
  cnpj = cnpj.replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, "$1.$2.$3");
  cnpj = cnpj.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, ".$1/$2");
  cnpj = cnpj.replace(/([0-9A-Z]{4})([0-9A-Z])/, "$1-$2");
  return cnpj;
};

// Detecta o tipo de documento aceitando CNPJ alfanumérico: qualquer letra ⇒
// CNPJ; caso contrário decide por comprimento (até 11 dígitos ⇒ CPF).
export const getDocType = (value) => {
  const alnum = onlyCnpjChars(value);
  if (/[A-Z]/.test(alnum)) return "CNPJ";
  return alnum.length > 11 ? "CNPJ" : "CPF";
};

// Aplica a máscara correta (CPF ou CNPJ) detectando o tipo automaticamente.
export const maskDocument = (value) =>
  getDocType(value) === "CNPJ"
    ? maskCNPJ(value)
    : maskCPF(String(value ?? "").replace(/\D/g, ""));

export const maskPhone = (phone) => {
  phone = phone.replace(/\D/g, "");
  if (phone.length <= 11) {
    phone = phone.replace(/(\d{2})(\d)/, "($1) $2");
    phone = phone.replace(/(\d{5})(\d)/, "$1-$2");
  }
  return phone;
};

export const maskLicensePlate = (plate) => {
  plate = plate.toUpperCase().replace(/[^A-Z0-9]/g, "");

  // Limita o comprimento máximo a 7 caracteres
  return plate.slice(0, 7);
};

export const maskChassi = (chassi) => {
  chassi = chassi.toUpperCase().replace(/[^A-HJ-NPR-Z0-9]/g, '');

  // Limita o comprimento máximo a 7 caracteres
  return chassi.slice(0, 17);
};
